<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. Montgomery, Alabama: February 4 to May 21, 1861</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Richmond, Virginia: May 1861 to July 1863</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Richmond, Virginia: July 1863 to April 2, 1865</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Danville, Virginia: April 3 to April 10, 1865</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Greensboro, North Carolina: April 14 to April 15, 1865</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Charlotte, North Carolina: April 19 to April 26, 1865</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The Flight of Jefferson Davis: South Carolina to Georgia, April 26 to May 10, 1865</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Looking for the Capitals of the Confederacy</span></p>
<p class="toc1"><span href="#/note" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3f8dcaa4